import { Eye } from "lucide-react";
import { helpRolesLabel } from "@/lib/toolbox/help";
import { TOOLBOX_TEXT } from "@/lib/toolbox/type-scale";
import { cn } from "@/lib/utils";

/**
 * "Help can see: Backlog · icentral-nt · Project Manager" (epic
 * PI-SPEC-SW-E302, feature PI-SPEC-SW-1557, frame H1, design `.hp-ctx`):
 * what is sent with every question. The app, SpecTree and pack versions go
 * too but are not shown. No screenshot is taken unless the person asks.
 */
export function HelpContextLine({
  screen,
  project,
  roles,
}: {
  screen: string;
  project: string | undefined;
  roles: readonly string[];
}) {
  const rest = [project, helpRolesLabel(roles)].filter((part): part is string => Boolean(part));
  return (
    <div
      className="flex flex-none items-center gap-2 border-b border-[#18181B] bg-[#0B0B0D] px-4 py-2"
      data-testid="help-context-line"
    >
      <Eye className={cn("h-[13px] w-[13px] flex-none", TOOLBOX_TEXT.faint)} aria-hidden="true" />
      <span className="min-w-0 flex-1 truncate text-xs text-muted-foreground">
        Help can see: <span className="text-[#FAFAFA]">{screen}</span>
        {rest.map((part) => ` · ${part}`).join("")}
      </span>
    </div>
  );
}
